import React from 'react';
import { Link } from 'react-router-dom';
import domesticStyles from './HeaderDomestic.module.css';

function SubNavIcon({ icon }) {
  if (icon === 'create-booking') {
    return (
      <svg
        className={[domesticStyles.subIcon, domesticStyles.subSvgIcon].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="4" y="4" width="16" height="16" rx="4.5" />
        <path d="M9 14h7" />
        <path d="M13 10h4" />
      </svg>
    );
  }

  if (icon === 'view-booking') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.viewBookingIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M5 8V6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5V8" />
        <path d="M19 16v1.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 17.5V16" />
        <path d="M6.5 12s2.1-4 5.5-4 5.5 4 5.5 4-2.1 4-5.5 4-5.5-4-5.5-4Z" />
        <circle cx="12" cy="12" r="1.7" />
      </svg>
    );
  }

  if (icon === 'update-booking') {
    return (
      <svg
        className={[domesticStyles.subIcon, domesticStyles.subSvgIcon].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="4" y="5.5" width="16" height="15" rx="2.5" />
        <path d="M4 10h16" />
        <path d="M8 3.5v4" />
        <path d="M12 3.5v4" />
        <path d="M16 3.5v4" />
      </svg>
    );
  }

  if (icon === 'cancel-booking') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.cancelBookingIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M7 3.3c-.9-.9-2.3-.9-3.2 0l-.5.5c-.9.9-.9 2.3 0 3.2L8.3 12l-5 5c-.9.9-.9 2.3 0 3.2l.5.5c.9.9 2.3.9 3.2 0l5-5 5 5c.9.9 2.3.9 3.2 0l.5-.5c.9-.9.9-2.3 0-3.2l-5-5 5-5c.9-.9.9-2.3 0-3.2l-.5-.5c-.9-.9-2.3-.9-3.2 0l-5 5-5-5Z" />
      </svg>
    );
  }

  if (icon === 'booking-dashboard') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.bookingDashboardIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="5" y="4" width="14" height="11" rx="2" />
        <path d="M10 18h4" />
        <path d="M12 15v3" />
        <path d="M7.5 20h9" />
      </svg>
    );
  }

  if (icon === 'manage-templates') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.manageTemplatesIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="3.5" y="4" width="17" height="16" rx="3" />
        <rect x="7.5" y="7" width="3" height="10" rx="1.5" />
        <rect x="13.5" y="7" width="3" height="10" rx="1.5" />
      </svg>
    );
  }

  if (icon === 'booking-details') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.bookingDetailsIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M6 10 10.5 3.5a1.8 1.8 0 0 1 3 0L18 10" />
        <circle cx="12" cy="4.8" r="0.8" />
        <rect x="4" y="9" width="16" height="11" rx="2.5" />
        <path d="M8 13h8" />
        <path d="M9.5 16h5" />
      </svg>
    );
  }

  if (icon === 'track-container') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.trackContainerIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M5 18.5V8.2c0-2 1.6-3.7 3.7-3.7h6.6c2 0 3.7 1.6 3.7 3.7v4.1" />
        <path d="M5 10h14" />
        <path d="M9 4.5 8 10" />
        <path d="M15 4.5 16 10" />
        <path d="M5 18.5h8.2" />
        <circle cx="16.5" cy="16.5" r="3" />
        <path d="M18.8 18.8 21 21" />
      </svg>
    );
  }

  if (icon === 'tracking-dashboard') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.trackingDashboardIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <rect x="4" y="4.5" width="16" height="11.5" rx="2.5" />
        <rect x="7" y="7.4" width="4.2" height="5.3" rx="1" />
        <path d="M14 8.2h3" />
        <path d="M14 11.8h2.3" />
        <path d="M10 19.5h4" />
        <path d="M12 16v3.5" />
      </svg>
    );
  }

  if (icon === 'shipping-instruction') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.shippingInstructionIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M4 17.5 8.2 12.7 11.2 15.7 16.6 6.5 20 10.2" />
        <circle cx="8.2" cy="12.7" r="1" />
        <circle cx="16.6" cy="6.5" r="1" />
      </svg>
    );
  }

  if (icon === 'vgm') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.vgmIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M4 5.5v13h15.5" />
        <path d="M7 15.5 10.8 12 13.7 13.9 18.8 8.6" />
      </svg>
    );
  }

  if (icon === 'billing-document') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.billingDocumentIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M8.8 15.5h6.4" />
        <path d="M10 18h4" />
        <path d="M12 21v-3" />
        <path d="M7.3 10.1a4.7 4.7 0 1 1 9.4 0c0 1.6-.8 2.5-1.7 3.4-.6.6-1.1 1.2-1.2 2h-3.6c-.1-.8-.6-1.4-1.2-2-.9-.9-1.7-1.8-1.7-3.4Z" />
        <path d="M12 3V1.8" />
        <path d="M5.7 5.8 4.8 4.9" />
        <path d="M18.3 5.8l.9-.9" />
        <path d="M4 11H2.8" />
        <path d="M21.2 11H20" />
      </svg>
    );
  }

  if (icon === 'blanket-loi') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.blanketLoiIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M4 5.5v13h15.5" />
        <path d="M7 15.5 10.8 12 13.7 13.9 18.8 8.6" />
      </svg>
    );
  }

  if (icon === 'container-search') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.containerSearchIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="10.5" cy="10.5" r="6.5" />
        <circle cx="10.5" cy="10.5" r="2.6" />
        <path d="M15.1 15.1 17.8 17.8" />
      </svg>
    );
  }

  if (icon === 'track-autos') {
    return (
      <svg
        className={[
          domesticStyles.subIcon,
          domesticStyles.subSvgIcon,
          domesticStyles.trackAutosIcon,
        ].join(' ')}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="12" cy="12" r="7.2" />
        <circle cx="12" cy="12" r="3.7" />
        <path d="M12 2.8v3" />
        <path d="M12 18.2v3" />
        <path d="M2.8 12h3" />
        <path d="M18.2 12h3" />
      </svg>
    );
  }

  return (
    <i
      className={`fa ${icon} ${domesticStyles.subIcon}`}
      aria-hidden="true"
    />
  );
}

/**
 * Data-driven domestic header sub-bar (booking / shipment tracking links).
 */
export const DOMESTIC_SUBNAV_RESELECT_EVENT = 'domestic-subnav-reselect';

export default function DomesticSubNav({ ariaLabel, links, subLinkClass, t }) {
  if (!links || links.length === 0) return null;

  return (
    <nav className={domesticStyles.subBar} aria-label={ariaLabel}>
      {links.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={subLinkClass(link.isActive)}
          onClick={
            link.reselect && link.isActive
              ? (e) => {
                  e.preventDefault();
                  window.dispatchEvent(
                    new CustomEvent(DOMESTIC_SUBNAV_RESELECT_EVENT, {
                      detail: link.to,
                    })
                  );
                }
              : undefined
          }
        >
          <SubNavIcon icon={link.icon} />
          {t(link.labelKey)}
        </Link>
      ))}
    </nav>
  );
}
